"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTokenStandardSerializer = exports.TokenStandard = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
var TokenStandard;
(function (TokenStandard) {
    TokenStandard[TokenStandard["NonFungible"] = 0] = "NonFungible";
    TokenStandard[TokenStandard["FungibleAsset"] = 1] = "FungibleAsset";
    TokenStandard[TokenStandard["Fungible"] = 2] = "Fungible";
    TokenStandard[TokenStandard["NonFungibleEdition"] = 3] = "NonFungibleEdition";
    TokenStandard[TokenStandard["ProgrammableNonFungible"] = 4] = "ProgrammableNonFungible";
    TokenStandard[TokenStandard["ProgrammableNonFungibleEdition"] = 5] = "ProgrammableNonFungibleEdition";
})(TokenStandard = exports.TokenStandard || (exports.TokenStandard = {}));
function getTokenStandardSerializer() {
    return (0, serializers_1.scalarEnum)(TokenStandard, {
        description: 'TokenStandard',
    });
}
exports.getTokenStandardSerializer = getTokenStandardSerializer;
//# sourceMappingURL=tokenStandard.js.map